import { tuluPost,post } from "@/api/request"

/* 直播 */
//列表
export const newslist = params => tuluPost("/app/found/getTypeNewsList", params)
export const newsListV2 = params => post("/v2/news/list", params)
export const hotspot = params => post("/v2/hot/spot", params)
export const videoDetail = params => post("/v2/organ/video/detail", params)
export const videoList = params => post("/v2/organ/video/list", params)
export const labelNews = params => post("/v2/label/news", params)
export const collectOrganList = params => post("/v2/collect/organ/list", params)
export const collectList = params => post("/v2/collect/list", params)